import { DeleteOutline } from '@mui/icons-material'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ConfirmDialog } from '@omnea-app/fe-legacy/components/layout/dialog/ConfirmDialog'

interface Props {
  onDelete: () => void
  isRenewal: boolean
  isPaused: boolean
  onClose?: () => void
}

const getBodyTexts = ({ isRenewal, isPaused, t }: { isRenewal: boolean; isPaused: boolean; t: (key: string) => string }) => {
  if (isRenewal) {
    return [t('deletion.confirm-description-with-renewal')]
  }
  return [t(isPaused ? 'deletion.confirm-description-paused' : 'deletion.confirm-description'), t('deletion.confirm-subtext')]
}

export const DeleteMenuItem = ({ onDelete, isRenewal, isPaused, onClose }: Props) => {
  const { t } = useTranslation('requests')
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const closeDialog = () => setIsDialogOpen(false)
  const openDialog = () => {
    setIsDialogOpen(true)
    onClose?.()
  }
  const handleConfirm = () => {
    onDelete()
    closeDialog()
  }

  const bodyTexts = getBodyTexts({ isRenewal, isPaused, t })

  return (
    <>
      <MenuItem color="danger" onClick={openDialog} data-testid="delete-request-menu-item">
        <ListItemIcon>
          <DeleteOutline />
        </ListItemIcon>
        <ListItemText primary={t('manage-request.delete')} />
      </MenuItem>
      <ConfirmDialog
        open={isDialogOpen}
        onClose={closeDialog}
        onConfirm={handleConfirm}
        title={isRenewal ? t('deletion.confirm-title-with-renewal') : t('deletion.confirm')}
        bodyTexts={bodyTexts}
        actions={[
          { variant: 'contained', color: 'secondary', text: t('deletion.back'), action: 'cancel' },
          { variant: 'contained', color: 'error', text: t('deletion.forward'), action: 'confirm' },
        ]}
      />
    </>
  )
}
